import config from "../authentication/config";

const servicesApiConstants = {
  UserManagement: "UserManagement",
  FileManagement: "FileManagement",
};

// VM and DP Permission
export const GET_DATA_API = `${config.API_SERVICE}/VMManagement/GetOrgDetails`;
export const GET_WMKS_API = `${config.API_SERVICE}/VMManagement/GetWebMKSToken`;
export const GET_PERMISSION_API = `${config.API_SERVICE}/UserManagement/GetUserPermissionResources`;
export const SHUT_DOWN_API = `${config.API_SERVICE}/VMManagement/ShutdownVM`;
export const REBOOT_API = `${config.API_SERVICE}/VMManagement/RebootVM`;
export const START_API = `${config.API_SERVICE}/VMManagement/StartVM`;
export const CREATE_SNAPSHOT_API = `${config.API_SERVICE}/VMManagement/CreateSnapshotVM`;
export const RESTORE_SNAPSHOT_API = `${config.API_SERVICE}/VMManagement/RestoreSnapshotVM`;
export const DELETE_SNAPSHOT_API = `${config.API_SERVICE}/VMManagement/DeleteSnapshotVM`;
export const RESET_API = `${config.API_SERVICE}/VMManagement/ResetVM`;
export const STOP_API = `${config.API_SERVICE}/VMManagement/StopVM`;
export const ISO_LIST_API = `${config.API_SERVICE}/VMManagement/GetISOList`;
export const MOUNT_ISO_API = `${config.API_SERVICE}/VMManagement/MountISO`;
export const UNMOUNT_ISO_API = `${config.API_SERVICE}/VMManagement/UnmountISO`;
export const GET_SNAP_LIST_API = `${config.API_SERVICE}/VMManagement/ViewSnapshotVM`;
// UserManagement
export const GET_ROLES_API = `${config.API_SERVICE}/UserManagement/GetUserRoles`;
export const GET_ASSIGNEDROLES_API = `${config.API_SERVICE}/UserManagement/GetAssignedUserRoles`;
export const DELETE_USER_API = `${config.API_SERVICE}/UserManagement/DeleteUserRoleBinding`;
export const ADD_SEARCH_USER_API = `${config.API_SERVICE}/UserManagement/InsertNewUserRoleBinding`;
export const UPDATE_USER_API = `${config.API_SERVICE}/UserManagement/UpdateExistingUserRoleBinding`;

// DataManagement
export const GET_TABLE_DATA_API = `${config.API_SERVICE}/FileManagement/GetAllFiles`;
export const UPLOAD_FILE_API = `${config.API_SERVICE}/FileManagement/Upload`;
export const TABLE_DATA_DELETE_API = `${config.API_SERVICE}/FileManagement/DeleteFiles`;
export const DASHBOARD_DOWNLOAD_RECORDS_API = `${config.API_SERVICE}/FileManagement/download`;
export const DASHBOARD_BLOB_SIZE_API = `${config.API_SERVICE}/FileManagement/GetStorageConsumption`;
export const DASHBOARD_FILE_RENAME_API = `${config.API_SERVICE}/FileManagement/ReNameFiles`;
export const DASHBOARD_FOLDER_RENAME_API = `${config.API_SERVICE}/FileManagement/ReNameFolder`;
export const DASHBOARD_UPLOAD_VALIDATION_API = `${config.API_SERVICE}/FileManagement/CheckFileNameExist`;
export const UPLOAD_CHUNK_API = `${config.API_SERVICE}/FileManagement/DashboardStageChunks`;
export const SEARCH_API = `${config.API_SERVICE}/FileManagement/GetFilesWithSearch`;
export const DASHBOARD_COMMIT_CHUNKS_API = `${config.API_SERVICE}/FileManagement/DashboardCommitChunks`;
export const DM_CANCEL_UPLOAD_API = `${config.API_SERVICE}/FileManagement/CancelUpload/largefileupload`;
export const DM_FILE_DOWNLOAD_API = `${config.API_SERVICE}/FileManagement/BrowserDownload`;

// https://digitalprimedev.honeywell.com/gateway/FileManagement/GetFilesWithSearch?searchFileName=dp
// CSRF
export const GET_XTOKEN = `${config.API_SERVICE}/UserManagement/xtoken`;

// Compare
export const COMPARE_API = `${config.API_SERVICE}/TwinCompare/TwinCompare`;
export const COMPARE_TWIN_API = `${config.API_SERVICE}/TwinCompare/TwinCollection`;
export const SUBMIT_FEEDBACK_API = `${config.API_SERVICE}/Feedback/SubmitUserFeedback`;

/** ACADEMY RELATED END POINTS */
export const GET_OSTYPES_API = `${config.API_SERVICE}/CourseManagement/GetOsTypes`;
export const GET_OSVERSIONS_API = `${config.API_SERVICE}/CourseManagement/GetOsVersionsByOsType`;
export const GET_COURSE_DEFINITION_LIST = `${config.API_SERVICE}/CourseManagement/GetCourseDefinitionList`;
export const GET_COURSE_COUNT_CARD = `${config.API_SERVICE}/CourseManagement/GetCourseCount`;
/** START - CREATE COURSE END POINTS */
export const GET_VAPP_TEMPLATES = `${config.API_SERVICE}/CourseManagement/GetVAppTemplateList`;
export const GET_VM_DETAILS_API = `${config.API_SERVICE}/CourseManagement/GetVmDetailsByVappTemplateId`;
export const GET_VAPP_TEMPLATES_VM_DETAILS_API = `${config.API_SERVICE}/CourseManagement/GetAllVAppTemplatesWithVmDetails`;
export const GET_NIC_NETWORK_API = `${config.API_SERVICE}/CourseManagement/GetAllNetworks`;
export const GET_NIC_NETWORK_ADAPTER_TYP_API = `${config.API_SERVICE}/CourseManagement/GetNetworkAdapterTypes`;
export const GET_NIC_IP_MODES_API = `${config.API_SERVICE}/CourseManagement/GetIPModes`;
export const CREATE_COURSE_DEFINITION = `${config.API_SERVICE}/CourseManagement/CreateCourseDefinition`;
export const UPDATE_COURSE_DEFINITION = `${config.API_SERVICE}/CourseManagement/UpdateCourseDefinition`;
export const PUBLISH_COURSE_DEFINITION = `${config.API_SERVICE}/CourseManagement/PublishDraftCourse`;
/** END - CREATE COURSE END POINTS */
export const GET_COURSE_INSTANCE_DEFINITION_LIST = `${config.API_SERVICE}/CourseManagement/GetCourseInstanceList`;
/** START - FILE MANAGEMENT END POINTS */
export const GETUSERPERMISSIONRESOURCES = `${servicesApiConstants.UserManagement}/GetUserPermissionResources`;
export const GETORGDETAILS = "/VMManagement/GetOrgDetails";
export const GETALLFILES = `${servicesApiConstants.FileManagement}/GetAllFiles`;
export const CHECKFILENAMEEXIST = `${servicesApiConstants.FileManagement}/CheckFileNameExist`;
export const DASHBOARDSTAGECHUNKS = `${servicesApiConstants.FileManagement}/DashboardStageChunks`;
export const DASHBOARDCOMMITCHUNKS = `${servicesApiConstants.FileManagement}/DashboardCommitChunks`;
export const DELETEFILES = `${servicesApiConstants.FileManagement}/DeleteFiles`;
export const GETSTORAGECONSUMPTION = `${servicesApiConstants.FileManagement}/GetStorageConsumption`;
export const DOWNLOADFILE = `${servicesApiConstants.FileManagement}/download`;
export const FILEEXISTS = `${servicesApiConstants.FileManagement}/CheckFileNameExist`;
export const GETFILESWITHSEARCH = `${servicesApiConstants.FileManagement}/GetFilesWithSearch`;
export const CANCEL_LARGE_FILES = `${servicesApiConstants.FileManagement}/CancelUpload/largefileupload`;
/** END - FILE MANAGEMENT END POINTS */
// ViewCourseInstanceAPI
export const VIEW_COURSE_INSTANCE_API = `${config.API_SERVICE}/CourseManagement/GetCourseInstanceById`;
// ViewCourseDefinitionAPI
export const VIEW_COURSE_DEFINITION_API = `${config.API_SERVICE}/CourseManagement/GetCourseDefinitionByID`;
//Delete Course Definition API
export const DELETE_COURSE_DEFINITION_API = `${config.API_SERVICE}/CourseManagement/DeleteCourseDefinition`;
//Course Instance End Points
export const DEPLOY_COURSE_INSTANCE_API = `${config.API_SERVICE}/CourseManagement/CreateCourseInstance`;
export const UPDATE_COURSE_INSTANCE_API = `${config.API_SERVICE}/CourseManagement/UpdateCourseInstance`;
/** START - ISO FILE MANAGEMENT END POINTS */
export const GetISOList = "/VMManagement/GetISOList";
export const UPLOADISO = "/VMManagement/UploadISO";
export const DELETEISO = "/VMManagement/DeleteISO";
export const DOWNLOADISO = "/VMManagement/DownloadISO";
export const UploadISOChunckingUI = "/VMManagement/UploadISOChunckingUI";
export const CANCELISO = "/VMManagement/CancelISO";
/** END - ISO FILE MANAGEMENT END POINTS */
//Delete Course Instance API
export const DELETE_COURSE_INSTANCE_API = `${config.API_SERVICE}/CourseManagement/DeleteCourseInstance`;
//Replace VM API
export const GET_VM_LIST = `${config.API_SERVICE}/CourseManagement/GetVmListBySiteId`;
export const REPLACE_VM_API = `${config.API_SERVICE}/CourseManagement/ReplaceVm`;
//Get Email Templates API
export const GET_EMAIL_TEMPLATES_API = `${config.API_SERVICE}/CourseManagement/GetEmailTemplates`;
